// services/botApiV2.js
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASEURL || 'http://localhost:3005';

/**
 * POST /api/bots/create
 * Body (example):
 * {
 *   name, exchange_id, symbol, timeframe,
 *   strategy: { buy, sell },
 *   order_sizing: { mode, value, asset_symbol },
 *   risk: {
 *     take_profit_pct, stop_loss_pct, trailing_stop_pct,
 *     max_daily_loss_pct, max_trades_per_day
 *   },
 *   tick_sensitive: boolean
 * }
 */
async function createBot(payload) {
  const { data } = await axios.post(
    `${API_BASE}/api/bots/create`,
    payload,
    {
      headers: { Authorization: localStorage.getItem('token') }
    }
  );
  return data;
}

export default {
  createBot,
};